<script>
    import CRUD from './CRUD.svelte';
    import { 
        fetchRoles, 
        saveRole, 
        removeRole, 
        searchRoles, 
        subscribeToRoles, 
        unsubscribeFromRoles 
    } from '../controllers/roleController.js';
    import { onMount } from 'svelte';
    import { t } from 'svelte-i18n';

    let roleColumns = [
        { label: $t('fields.description'), field: 'descrip', type: 'text' },
        { label: $t('fields.state'), field: 'sta', type: 'bool' },
    ];

    let newRole = {
        descrip: '',
        sta: true,
    };

    let editColumns = [
        { label: $t('fields.description'), key: 'descrip', type: 'text', required: true },
        { label: $t('fields.state'), key: 'sta', type: 'checkbox' },
    ];

    onMount(() => {
        console.log("Componente de Roles montado");
    });
</script>

<CRUD 
    title={$t('entities.roles')}
    entityName="role"
    newEntity={newRole}
    columns={roleColumns}
    fetchEntities={fetchRoles}
    saveEntity={saveRole}
    removeEntity={removeRole}
    searchEntities={searchRoles}
    subscribeToChanges={subscribeToRoles}
    unsubscribeFromChanges={unsubscribeFromRoles}
    editColumns={editColumns}
/>